<template>
  <div
    class="hidden w-full items-center gap-6 border-2 border-orange p-6 text-center text-grey-100 xs:flex lg:text-left"
  >
    <IconLightBulb class="hidden h-16 w-16 text-orange lg:block" />

    <div>
      <h3 class="mb-2 text-2xl font-bold">
        {{ title }}
      </h3>
      <p class="text-lg">
        {{ content }}
      </p>
    </div>
  </div>
</template>

<script>
import IconLightBulb from 'Components/Icons/IconLightBulb.vue';

export default {
  name: 'DidYouKnow',
  components: { IconLightBulb },
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.$emit('didyouknowscroll');
  }
};
</script>
